import { DatabaseWrapper } from 'src/app/shared/databases/database.wrapper';
import { Database } from 'src/app/shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class IotHubWrapper extends DatabaseWrapper {
	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.iothub.ID;
		this.name = DatabaseEnum.iothub.NAME;
		this.code = DatabaseEnum.iothub.CODE;
		this.equivalentTag = DatabaseEnum.iothub.EQUIVALENT_TAG;
		this.showClevel = true;
		this.showDatabaseTab = false;
		this.showLoadPropertiesTab = false;
    this.showDataDescription = false;
	}

	validateRepConn(repConnWrapper: RepConnWrapper) {
		if (repConnWrapper.repConn.conn.kafka_Regex == "") {
			repConnWrapper.inValid_Cds.push('IOTHUB_NAME');
		}

		if (repConnWrapper.repConn.conn.topic == "") {
			repConnWrapper.inValid_Cds.push('IOT_TOPIC');
		}

		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}
	}

	getAttributeColumns(objectWrapper: ObjectWrapper,
        attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
		if (!this.attributeColumns) {
			this.attributeColumns = [
				this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
				this.attributeTabulator.getSrt_Order(),
				this.attributeTabulator.getAttr_Id(),
				this.attributeTabulator.getAttrNm(objectWrapper,component),
				this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
				this.attributeTabulator.getAttrPrec(objectWrapper),
				this.attributeTabulator.getAttrScale(objectWrapper),
				this.attributeTabulator.getDescription(objectWrapper),
			]
			return this.attributeColumns;
		}

		return this.attributeColumns;
	}


	getSourceAttributeColumns(objectWrapper: ObjectWrapper = null, isComplex: boolean = false,
		isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isMax: boolean = false,component:any): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getDistKeyFlag(objectWrapper),
			this.attributeTabulator.getOrgKeyFlag(objectWrapper),
			this.attributeTabulator.getOrderBy(objectWrapper, component),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper,component),
		]
	}
}
